package com.milta.core.localization.translations.de

import com.milta.core.localization.AdminUsersStrings

internal val AdminUsers = AdminUsersStrings(
    loading = "Wird geladen…",
    errorNoConnection = "Server nicht erreichbar — bitte Verbindung prüfen.",
    errorGeneric = "Ein Fehler ist aufgetreten. Bitte später erneut versuchen.",
    readOnlyNotice = "🔒 Nur Ansicht — von diesem Bildschirm aus kann derzeit kein Konto erstellt, bearbeitet oder gesperrt werden.",
    kpiAccountsLabel = "Konten",
    kpiAccountsSubtitle = "alle Rollen zusammen",
    kpiDriversLabel = "Fahrer",
    kpiDriversSubtitle = "ohne eigenes Team",
    kpiPatronsLabel = "Inhaber",
    kpiPatronsOrgSingular = "Organisation",
    kpiPatronsOrgPlural = "Organisationen",
    kpiActiveSubsLabel = "Aktive Abonnements",
    kpiActiveSubsSubtitle = "aktiv + Kulanzzeit",
    kpiAtRiskLabel = "Gefährdet",
    kpiAtRiskSubtitle = "Testphase oder abgelaufen",
    searchPlaceholder = "Suche nach Name, E-Mail, Organisation…",
    expandAllAction = "Alle ausklappen",
    collapseAllAction = "Alle einklappen",
    columnAccount = "Konto",
    columnContact = "Kontakt",
    columnType = "Typ",
    columnAddedDate = "Hinzugefügt / erstellt am",
    columnSubscription = "Abonnement",
    columnSince = "Seit",
    columnRenewal = "Verl.",
    noOrganizationHeader = "Ohne Organisation",
    emptySearchResult = "Kein Konto entspricht dieser Suche.",
    patronBadgePrefix = "Inhaber",
    createdOnPrefix = "Erstellt am",
    emptyTeamMessage = "Noch kein Fahrer in diesem Team.",
    driverBadge = "Fahrer",
    addedOnPrefix = "Hinzugefügt am",
    viaOrganization = "Über Organisation",
    accountCreatedOnUnknown = "Konto erstellt am —",
    renewalSingular = "Verlängerung",
    renewalPlural = "Verlängerungen",
    subscriptionNone = "Keine",
    subscriptionActive = "Aktiv",
    subscriptionTrial = "Testphase",
    subscriptionGrace = "Kulanz",
    subscriptionExpiredStatus = "Abgelaufen",
    subscriptionCancelled = "Gekündigt",
    planOrganization = "Organisation",
    planDriver = "Fahrer",
)
